import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { DirectoryColumns } from '../components/hub/DirectoryColumns';
import { HubFaqs } from '../components/hub/HubFaqs';
import { SiblingHubs } from '../components/hub/SiblingHubs';
import { DesignNote } from '../components/DesignNote';
import { beachKit, beachesFaqs, beachesIntro, beachesTier3, rankedBeaches, shortAnswer, timing } from '../data/beaches';
export function Beaches() {
  return <main id="main" className="bg-paper" data-id="element-433" data-mp="2gw17z62j7h6y">
      <div className="mx-auto max-w-shell px-6 pb-12 pt-8 lg:px-10" data-id="element-434" data-mp="2guq312xco3e9">
        <nav aria-label="Breadcrumb" data-id="element-435" data-mp="2loc6c4hmiuxe">
          <ol className="flex flex-wrap items-center gap-2 text-[12.5px] text-muted" data-id="element-436" data-mp="2lpdrj1scsxsu">
            <li data-id="element-437" data-mp="2qlko43yv0wy4">
              <Link to="/" className="hover:text-ink hover:underline" data-id="element-438" data-mp="2qo6w24pnxegv">
                Home
              </Link>
            </li>
            <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-439" data-mp="2zmiuuu0onike" />
            <li data-id="element-440" data-mp="2zkpkp4qv2g7n">
              <Link to="/things-to-do" className="hover:text-ink hover:underline" data-id="element-441" data-mp="1h2z03c7snlnu">
                Things to do
              </Link>
            </li>
            <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-442" data-mp="1d02c15zhixci" />
            <li aria-current="page" className="text-ink" data-id="element-443" data-mp="183ln49kgoeyd">
              Beaches with kids
            </li>
          </ol>
        </nav>

        <DesignNote label="Evergreen guide — the money page" note="Third page shape: not a hub and not a category. A ranked, opinionated article built to rank for one high-value search and to carry affiliate revenue." data-id="element-444" data-mp="135afm5hn2gjb" />

        <div className="max-w-3xl" data-id="element-445" data-mp="1r0va20ozwakd">
          <p className="label text-olive" data-id="element-446" data-mp="1qztvvncon7yf">{beachesIntro.meta}</p>
          <h1 className="mt-6 font-display text-[48px] font-300 leading-[0.98] text-ink sm:text-[66px]" data-id="element-447" data-mp="1m33gz3cm6iel">
            The 12 best Santa Barbara beaches{' '}
            <span className="italic" data-id="element-448" data-mp="2jjinctxr2law">with kids</span>
          </h1>
          <p className="mt-7 max-w-prose text-[18px] font-300 leading-[1.7] text-ink/75" data-id="element-449" data-mp="2eq7gissxu4iz">
            {beachesIntro.deck}
          </p>
          <p className="mt-7 text-[13px] text-muted" data-id="element-450" data-mp="cvt5g0swo3h8">
            By {beachesIntro.author} · {beachesIntro.published}
          </p>
        </div>

        <img src={beachesIntro.hero} alt={beachesIntro.heroAlt} className="photo-soft mt-14 aspect-[21/9] w-full object-cover" data-id="element-451" data-mp="32kowpsszvpa" />
      </div>

      <ShortAnswer data-id="element-452" data-mp="3pac8axq966u2" />
      <Timing data-id="element-453" data-mp="3p9smv71e90ba" />
      <Ranked data-id="element-454" data-mp="3p9ajlqgbdltv" />
      <BeachKit data-id="element-455" data-mp="3p9izzsbnb99t" />

      <DirectoryColumns title="More beaches, and what to read next" groups={beachesTier3} data-id="element-456" data-mp="3pd6oue65b7i7" />
      <HubFaqs faqs={beachesFaqs} data-id="element-457" data-mp="3u7kfk39v4qgj" />
      <SiblingHubs exclude={['Things to do']} data-id="element-458" data-mp="3gap7oe5cl522" />
    </main>;
}
function ShortAnswer() {
  return <section aria-labelledby="short-h" className="bg-foam/40" data-id="element-459" data-mp="3l8gvavyym50g">
      <div className="mx-auto grid max-w-shell gap-x-20 gap-y-12 px-6 py-16 lg:grid-cols-[1.3fr_1fr] lg:px-10 lg:py-20" data-id="element-460" data-mp="3lb3ddpjh82wx">
        <div data-id="element-461" data-mp="1jhm0a6cku9us">
          <DesignNote label="Built for the featured snippet" note="Google pulls a direct answer from a short paragraph near the top. Answer the question in plain sentences before the article starts." data-id="element-462" data-mp="1ji5htlybew8a" />
          <h2 id="short-h" className="font-display text-[34px] font-300 leading-tight text-ink" data-id="element-463" data-mp="1ookc9nqwc1xg">
            {shortAnswer.title}
          </h2>
          <p className="mt-6 max-w-prose text-[17px] leading-[1.9] text-ink/85" data-id="element-464" data-mp="1xmm7tnrv22dc">
            {shortAnswer.body}
          </p>
        </div>

        <dl className="self-start border-t border-ink/20" data-id="element-465" data-mp="2ce4w08uvj37s">
          {shortAnswer.picks.map(pick => <div key={pick.label} className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1 border-b border-ink/15 py-5" data-id="element-466" data-mp="2ld02zn5qshc5">
              <dt className="label text-ink/60" data-id="element-467" data-mp="2h9agr4cjibua">{pick.label}</dt>
              <dd className="font-display text-[21px] font-400 leading-snug text-ink" data-id="element-468" data-mp="r00gda2y2mvd">
                {pick.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}
function Timing() {
  return <section aria-labelledby="timing-h" className="border-t border-line bg-white" data-id="element-469" data-mp="ognazg34yflv">
      <div className="mx-auto max-w-shell px-6 py-16 lg:px-10 lg:py-20" data-id="element-470" data-mp="tbsw4coprq8w">
        <DesignNote label="Local knowledge, not a listicle" note="This section is why someone links to this page instead of a national travel site. It is the part no chain publisher knows." data-id="element-471" data-mp="xgah2f6t89l9" />
        <h2 id="timing-h" className="max-w-2xl font-display text-[34px] font-300 leading-tight text-ink" data-id="element-472" data-mp="5pmgb491t684">
          Three things that decide the day before you pick a beach
        </h2>

        <ol className="mt-12 grid gap-x-16 gap-y-10 border-t border-line pt-12 lg:grid-cols-3" data-id="element-473" data-mp="emmyuu9fsa3n">
          {timing.map((item, i) => <li key={item.title} data-id="element-474" data-mp="3i5zssjc7vf9q" data-mpi={i}>
              <p className="font-display text-[30px] font-300 leading-none text-ink/30" data-id="element-475" data-mp="3i4oq6muicdk7">
                {String(i + 1).padStart(2, '0')}
              </p>
              <h3 className="mt-4 font-display text-[24px] font-300 leading-tight text-ink" data-id="element-476" data-mp="3fks2hb14zfw5">
                {item.title}
              </h3>
              <p className="mt-3 text-[15px] leading-[1.8] text-muted" data-id="element-477" data-mp="3an8ma5kvot1k">
                {item.body}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}
function Ranked() {
  return <section aria-labelledby="ranked-h" className="bg-paper" data-id="element-478" data-mp="31kzgtu4gvpv1">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-24" data-id="element-479" data-mp="2wn7nqws35xp9">
        <h2 id="ranked-h" className="max-w-2xl font-display text-[38px] font-300 leading-[1.05] text-ink sm:text-[46px]" data-id="element-480" data-mp="2rvpkg22lbl14">
          The beaches, ranked
        </h2>
        <p className="mt-5 max-w-prose text-[15.5px] leading-[1.8] text-muted" data-id="element-481" data-mp="2hxjlntc2yv0h">
          Six written up in full below. The rest are listed at the bottom.
        </p>

        <ol className="mt-16 space-y-20" data-id="element-482" data-mp="2duverr6xfy65">
          {rankedBeaches.map(beach => <li key={beach.slug} data-id="element-483" data-mp="28x3k4pewdxy9">
              <article className="border-t border-line pt-10" data-id="element-484" data-mp="1z8zbhwe0cs3n">
                <div className="grid gap-x-16 gap-y-10 lg:grid-cols-[1fr_340px]" data-id="element-485" data-mp="1z7ek2fmzppa0">
                  <div data-id="element-486" data-mp="23bchmlwo2s0y">
                    <div className="flex items-baseline gap-6" data-id="element-487" data-mp="23bvwtuuxn2ba">
                      <span className="font-display text-[46px] font-300 leading-none text-ink/30" aria-hidden="true" data-id="element-488" data-mp="1pbtk0n1hez2w">
                        {String(beach.rank).padStart(2, '0')}
                      </span>
                      <div data-id="element-489" data-mp="2mz20g3mmlhy1">
                        <h3 className="font-display text-[34px] font-300 leading-tight text-ink" data-id="element-490" data-mp="2mx8uyrnr13rm">
                          {beach.name}
                        </h3>
                        <p className="label mt-2 text-olive" data-id="element-491" data-mp="2d87d0vxn8cb0">{beach.area}</p>
                      </div>
                    </div>

                    <p className="mt-8 max-w-prose font-display text-[24px] font-300 italic leading-snug text-ink" data-id="element-492" data-mp="30xjm7vsz0kdb">
                      {beach.verdict}
                    </p>
                    <p className="mt-6 max-w-prose text-[16.5px] leading-[1.9] text-ink/80" data-id="element-493" data-mp="u99i8frj7mn9">
                      {beach.body}
                    </p>

                    <p className="mt-8 max-w-prose border-l-2 border-olive pl-6 text-[15px] leading-[1.8] text-ink/80" data-id="element-494" data-mp="p8vj5n7wrn1d">
                      <span className="label mb-1.5 block text-olive" data-id="element-495" data-mp="z0rlxbkxw1bx">
                        Know before you go
                      </span>
                      {beach.knowBefore}
                    </p>
                  </div>

                  <div data-id="element-496" data-mp="6d5gdxs5immf">
                    {beach.image && <img src={beach.image} alt={beach.imageAlt} className="photo-soft mb-8 aspect-[4/3] w-full object-cover" data-id="element-497" data-mp="kbvdhdez0mas" />}
                    <dl className="border-t border-line" data-id="element-498" data-mp="1vpqr2hq88mzw">
                      {[['Water', beach.water], ['Bathrooms', beach.bathrooms], ['Shade', beach.shade], ['Parking', beach.parking], ['Carry from car', beach.carry], ['Best for', beach.bestFor]].map(([term, value]) => <div key={term} className="flex items-baseline justify-between gap-6 border-b border-line py-3" data-id="element-499" data-mp="2olgg1j9kequr">
                          <dt className="label text-muted/70" data-id="element-500" data-mp="2yjnw7zw154vp">{term}</dt>
                          <dd className="text-right text-[14px] leading-snug text-ink" data-id="element-501" data-mp="2yhtbalkrdcrm">
                            {value}
                          </dd>
                        </div>)}
                    </dl>
                  </div>
                </div>
              </article>
            </li>)}
        </ol>
      </div>
    </section>;
}
function BeachKit() {
  return <section aria-labelledby="kit-h" className="border-t border-line bg-creme/50" data-id="element-502" data-mp="1d8e08qfai5bn">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-24" data-id="element-503" data-mp="15od48bv5zj8g">
        <DesignNote label="Affiliate placement, disclosed" note="Put it after the value, never before. Disclosure sits directly under the heading where it cannot be missed." data-id="element-504" data-mp="10v0ut8z23j0a" />
        <div className="grid gap-x-20 gap-y-10 lg:grid-cols-[1fr_1.4fr]" data-id="element-505" data-mp="rwf2im3s8pmb">
          <div data-id="element-506" data-mp="1om69hkt9g590">
            <p className="label text-ink/55" data-id="element-507" data-mp="1olwflm53hdy1">The beach day kit</p>
            <h2 id="kit-h" className="mt-5 font-display text-[36px] font-300 leading-[1.08] text-ink" data-id="element-508" data-mp="1jmjub5tvgexk">
              {beachKit.title}
            </h2>
            <p className="mt-6 max-w-sm text-[13.5px] leading-[1.8] text-ink/60" data-id="element-509" data-mp="1fmsvqfy3suih">
              {beachKit.note}
            </p>
          </div>

          <ul className="border-t border-ink/15" data-id="element-510" data-mp="46uhzyrzdkax">
            {beachKit.items.map(item => <li key={item.name} className="grid gap-x-10 gap-y-2 border-b border-ink/15 py-6 sm:grid-cols-[1fr_auto]" data-id="element-511" data-mp="3vb2pj0wmq9ss">
                <div data-id="element-512" data-mp="2rz148ibb2cvv">
                  <h3 className="font-display text-[24px] font-300 leading-snug text-ink" data-id="element-513" data-mp="2rzkdzbqsxuyt">
                    {item.name}
                  </h3>
                  <p className="mt-2 max-w-prose text-[14.5px] leading-[1.8] text-ink/70" data-id="element-514" data-mp="35sa9q7w4ue94">
                    {item.why}
                  </p>
                </div>
                <div className="sm:text-right" data-id="element-515" data-mp="3fnai8y2a1wcg">
                  <p className="label text-ink/60" data-id="element-516" data-mp="3fq6hcppv2r2h">{item.price}</p>
                  <a href="#faq" className="label mt-3 inline-block border border-ink/30 px-5 py-2.5 text-ink transition-colors duration-150 ease-soft hover:bg-ink hover:text-paper" data-id="element-517" data-mp="3aoqwaxnookk3">
                    Where we buy it
                  </a>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}